import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createStaticVNode("<g stroke-linecap=\"round\" stroke-linejoin=\"round\" clip-path=\"url(#a)\"><path stroke=\"#A7A7B1\" stroke-width=\".938\" d=\"M2.39 4.71h7.22M2.39 7.29h7.22M5.784 2.132a7.3 7.3 0 0 0 0 7.734m.43-7.734a7.3 7.3 0 0 1 0 7.734M2.133 6a3.867 3.867 0 1 0 7.734 0 3.867 3.867 0 0 0-7.734 0\" style=\"stroke:color(display-p3 .6543 .6543 .6951);stroke-opacity:1;\"></path><path stroke=\"#000\" stroke-width=\"2.625\" d=\"M9.563 7.313v3m-1.5-1.5h3\" style=\"stroke:#000;stroke-opacity:1;\"></path><path stroke=\"#fff\" d=\"M9.563 7.313v3m-1.5-1.5h3\" style=\"stroke:#fff;stroke-opacity:1;\"></path></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h12v12H0z\" style=\"fill:#fff;fill-opacity:1;\"></path></clipPath></defs>", 2)
  ])))
}
export default { render: render }